"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
exports.default = ({ week, date }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: week }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: date }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  h2,
  p {
    margin-bottom: 0;
    line-height: 1rem;
  }

  h2 {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
    text-transform: capitalize;
  }
`;
//# sourceMappingURL=Info.js.map